// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel[data-v-7036c5a5] {\n  margin-top: 3px;\n}\n", ""]);
// Exports
module.exports = exports;
